export default __webpack_public_path__ + "static/media/colorblind_blue.561a1983.svg";